import { Box } from '@hivebrite/design-system/Box';

import ButtonLink from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ButtonLink';
import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import DisplayOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayOption';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

const Buttons = ({
  item,
  onChange,
}: Omit<ComponentSettingsTab<ButtonItemAttributes>, 'defaultAttributes'>) => (
  <>
    <DisplayOption
      title={__('Display button')}
      item={item}
      onChange={onChange}
    />
    <TextSetting
      item={item}
      onChange={onChange}
      placeholder={__('Content')}
      settingKey="content"
      title={__('Content')}
    />
    <Box display="block" width="100%">
      <ButtonLink
        item={item}
        onChange={onChange}
        withToolTipDescription={__(
          'Use %{User_ID} in your links to personalize it to each user',
        )}
      />
    </Box>
    <CheckboxSetting
      item={item}
      onChange={onChange}
      settingKey="buttonLinkNewPage"
      title={s__('Builder|Open link in a new tab')}
    />
  </>
);

export default Buttons;
